import { CardHistoricoProps } from "../../Base/types";
import CardHistoricoBase from "../../Base/CardHistoricoBase";
import { MessageSquare, Pencil, Trash2, LucideIcon } from "lucide-react";
import ExpandedContent from "./ExpandedContent";

const detectaComentario = (acao: string): boolean => {
    const acaoLower = acao.toLowerCase().trim();
    return acaoLower.includes('comentário criado') || 
           acaoLower.includes('comentario criado') ||
           acaoLower.includes('resposta adicionada') ||
           acaoLower.includes('comentário editado') ||
           acaoLower.includes('comentario editado') ||
           acaoLower.includes('comentário excluído') ||
           acaoLower.includes('comentario excluido') ||
           acaoLower.includes('sequência de comentários excluída') ||
           acaoLower.includes('sequencia de comentarios excluida');
};

const getIconComentario = (acao: string): { Icon: LucideIcon; color: string } => {
    const acaoLower = acao.toLowerCase().trim();
    if (acaoLower.includes('excluído') || acaoLower.includes('excluido') || acaoLower.includes('sequência de comentários excluída') || acaoLower.includes('sequencia de comentarios excluida')) {
        return { Icon: Trash2, color: 'var(--ce5293f)' };
    }
    if (acaoLower.includes('comentário editado') || acaoLower.includes('comentario editado')) {
        return { Icon: Pencil, color: 'var(--c8041c7)' };
    }
    return { Icon: MessageSquare, color: 'var(--c2e86de)' };
};

export default function CardComentario({ item, onNavigateToFile, isExpanded, onToggleExpand }: CardHistoricoProps) {
    const acaoLower = item.acao.toLowerCase().trim();
    const isResposta = acaoLower.includes('resposta adicionada');
    const isEditado = acaoLower.includes('comentário editado') || acaoLower.includes('comentario editado');
    const isExcluido = acaoLower.includes('excluído') || acaoLower.includes('excluido') || acaoLower.includes('sequência de comentários excluída') || acaoLower.includes('sequencia de comentarios excluida');
    
    let titulo = 'Comentário criado';
    if (isResposta) {
        titulo = 'Comentário respondido';
    } else if (isEditado) {
        titulo = 'Comentário Editado';
    } else if (isExcluido) {
        if (acaoLower.includes('sequência') || acaoLower.includes('sequencia')) {
            titulo = 'Sequência de comentários excluída';
        } else {
            titulo = 'Comentário excluído';
        }
    }
    
    return (
        <CardHistoricoBase
            item={item}
            icon={getIconComentario(item.acao)}
            temExpansaoDisponivel={true}
            isExpanded={isExpanded}
            onToggleExpand={onToggleExpand}
            expandedContent={<ExpandedContent item={item} onNavigateToFile={onNavigateToFile} />}
            tituloCustomizado={titulo}
        />
    );
}

export const comentarioConfig = {
    tipo: 'comentario',
    detectaTipo: detectaComentario,
    getIcon: getIconComentario,
    temExpansao: () => true,
    Component: CardComentario
};



